import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import styles from './Select.module.scss';
import FormElement from '../FormElement';
import { dataResources } from '@portal-internet/core';
import { ReactSVG } from 'react-svg';

const { basePath } = dataResources;

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <ReactSVG src={basePath + '/_resources/REDL/icons/chevron-down.svg?v=JIT_ENV_RESOURCES_VERSION'} />
            </components.DropdownIndicator>
        )
    );
};

const ClearIndicator = props => {
    return (
        components.ClearIndicator && (
            <components.ClearIndicator {...props}>
                <ReactSVG src={basePath + '/_resources/REDL/icons/x.svg?v=JIT_ENV_RESOURCES_VERSION'} />
            </components.ClearIndicator>
        )
    );
};

export default function SelectComponent({ value, options, label, desc, onChange }) {
    return (
        <FormElement label={label} desc={desc}>
            <CreatableSelect
                isClearable
                value={value}
                options={options}
                className={styles.redlSelect}
                onChange={onChange}
                formatCreateLabel={userInput => `Crear ${userInput}`}
                placeholder="Seleccionar"
                components={{ DropdownIndicator, ClearIndicator }}
                styles={{
                    valueContainer: (base) => ({
                        ...base,
                        fontSize: '0.9rem'
                    })
                }}
            />
        </FormElement>
    );
}